import { createSlice } from "@reduxjs/toolkit";
import { current } from "@reduxjs/toolkit";
import { safeParse, uuid6 } from "../helpers/helper";

const initialState = {
members:[],
preload:{},
webhooks:[],
role:{},
apiKey:"",
enableApiKey:false,
preloadComplete : false,
configLoaded : false,
defaultInvoiceConfig:"",
invoiceConfigs:[],
    roles:[],
  types : {},
  constants :{},
  conditionals :{},
  taxConfigs:[],
  changes : {
    types : {},
    constants:{},
    conditionals:{},
    taxConfigs:[]
  },
  hasLocalChanges:false,
  id: sessionStorage.getItem('selectedWorkspace')
};

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState: initialState,
  reducers: {
    setWorkspaceRoles:(state,action)=>{
        state.roles = action.payload
    },
    setInvoiceConfigs:(state,action)=>{
        state.invoiceConfigs = action.payload
    },
    setWorkspaceSettings : (state , action) => {
        if (!action.payload) return
        const config = safeParse(action.payload.config)
        Object.keys(config).map(key=>{
            state[key]=config[key]
        })
        state.apiKey = action.payload.apiKey
        state.enableApiKey = action.payload.enableApiKey
        state.workspaceSettingsId = action.payload.id
        state.configLoaded = true
        state.hasLocalChanges=false
        state.defaultInvoiceConfig = action.payload.defaultInvoiceConfig
        if (action.payload.plan){
        state.plan = action.payload.plan
        }
        if (action.payload.notifications){
        state.notifications = action.payload.notifications
        }
        if (action.payload.usage){
        state.usage=action.payload.usage
        }
        if (action.payload.role){
        state.role=safeParse(action.payload.role)
        }
        if(action.payload.loggedInUser){
            state.loggedInUser = action.payload.loggedInUser
        }

    },
    setDefaultInvoiceConfig:(state,action)=>{
        state.defaultInvoiceConfig = action.payload
    },
    setWebhooks:(state,action)=>{
        state.webhooks = action.payload
    },
     setPreload:(state,action)=>{

      state.preload = action.payload
      state.preloadComplete = true
    },
    setChanges : (state , action) => {
        const {changeKey , key , keyPath , value}= action.payload
        let tmpState = state['changes'][changeKey]
        if (keyPath){
            for (var i=0;i<keyPath.length-1;i++){
                tmpState = tmpState[keyPath[i]]
            }

            tmpState[keyPath[i]] = value

        } else if(key == ''){
            state['changes'][changeKey] = value
        } else {
            state['changes'][changeKey][key] = value
        }
    } ,
    // setToBeSaved : (state,action)=>{
    //     const {changeKey , key }= action.payload

    //     if (state[changeKey][key]  !== state['changes'][changeKey][key]){
    //         state['toBeSaved'][changeKey][key] = state['changes'][changeKey][key]
    //     }
    //     delete state['changes'][changeKey][key]


    // },
    saveChangesLocally : (state,action)=>{
        const {changeKey , key }= action.payload

        if(key == ''){
            state[changeKey] = JSON.parse(JSON.stringify(state['changes'][changeKey]))
            state.hasLocalChanges=true
        } else {
        if(state[changeKey][key] !== state['changes'][changeKey][key]){
        state[changeKey][key] = JSON.parse(JSON.stringify(state['changes'][changeKey][key]))
        state.hasLocalChanges=true
        }
    }

    },
    cancelChange : (state,action) =>{
        const {changeKey , key }= action.payload
        delete state['changes'][changeKey][key]
    },
    addNewType : (state,action)=>{
        const typeId = action.payload
        const taxConfig = state.taxConfigs?.[0]?.['id']
        state.types[typeId] = {
            "name" : "New Type "+typeId,
            "taxConfig":taxConfig
        }
        state.changes.types[typeId] = {
            "name" : "New Type "+typeId,
            "taxConfig":taxConfig
        }
    },
    setWorkspaceMembers:(state,action)=>{
        state.members = action.payload
    }

  }
});

export const {setDefaultInvoiceConfig,setInvoiceConfigs,setWebhooks,setWorkspaceRoles,setWorkspaceMembers,addNewType,saveChangesLocally,setChanges,setWorkspaceSettings,setPreload,setToBeSaved,cancelChange} = workspaceSlice.actions;
export default workspaceSlice.reducer;
